/** Admin settings → Permissions: tick who gets the in-app browser in their menu bar. */
import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import api from "@/lib/api";

export default function BrowserAccessPanel() {
  const [access, setAccess] = useState(null);
  const load = () => api.get("/browser/access").then((r) => setAccess(r.data)).catch(() => setAccess(null));
  useEffect(() => { load(); }, []);
  if (!access?.users) return null;
  return (
    <div className="mt-6 rounded-lg border border-white/10 bg-white/[0.03] p-4" data-testid="settings-browser-access">
      <p className="flex items-center gap-2 text-sm font-semibold text-white"><Globe className="h-4 w-4" /> Web browser</p>
      <p className="mt-1 font-mono text-[10px] text-white/50">
        Adds the browser icon to the menu bar. Owners, superadmins and admins have it by default; bookmarks, history and saved logins are shared between everyone who has it.
      </p>
      <div className="mt-2 grid grid-cols-1 gap-1 sm:grid-cols-2">
        {access.users.map((u) => (
          <label key={u.user_id} className="flex items-center gap-2 rounded-md px-2 py-1 text-xs text-white/85 hover:bg-white/5">
            <input type="checkbox" className="h-4 w-4 accent-[#1a3fd1]" checked={u.enabled} data-testid={`settings-browser-access-${u.user_id}`}
              onChange={async (e) => { await api.put("/browser/access", { user_id: u.user_id, enabled: e.target.checked }); load(); window.dispatchEvent(new Event("elite:browser-access-changed")); }} />
            <span className="truncate">{u.name}</span>
            <span className="ml-auto shrink-0 font-mono text-[9px] uppercase tracking-wider text-white/45">{u.role}{u.by_role ? " · default" : ""}</span>
          </label>
        ))}
      </div>
    </div>
  );
}
